module.exports = __webpack_public_path__ + "d286d5ee708e45287dec8dd790abc438.svg";